import { Injectable } from '@angular/core';
import {Service} from "./service";
// import 'rxjs/add/operator/toPromise';
// import 'rxjs/add/operator/retry';
import {retry} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DocumentSigningService extends Service{

    async getLogin() {
        const response = await this.http.get(this.format_url('external/plain_signature/authorize_login'), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async getInfo(_obj: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/get_info'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async cuLogout() {
        const response = await this.http.get(this.format_url('external/plain_signature/logout'), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async getCitizen(_obj: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/get_citizen'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async getDocument(_obj: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/get_document'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async download_document(params: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/download_document'), params, this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async authSign(_obj: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/auth_sign'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async rejectSign(_obj: Object) {
        const response = await this.http.post(this.format_url('external/plain_signature/reject_sign'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }

    async cancel_case(_obj: Object) {
        const response = await this.http.post(this.format_url('wf_cases/cancel_case'), this.set_data(_obj), this.jwt()).pipe(retry(Service.retry)).toPromise();
        return this.set_response(response['ed']);
    }
}
